import { defineComponent as _defineComponent } from 'vue'


// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'FogoNightlyBanner',
  props: {
    canDismiss: { type: Boolean }
  },
  emits: ['dismiss'],
  setup(__props: any, { emit }) {

const props = __props as {
	canDismiss?: boolean;
};



// Emits


// Methods
function dismissBanner() {
	if (!props.canDismiss) return;
	localStorage.setItem('fogo-nightly-banner-dismissed', 'true');
	emit('dismiss');
}

return { __sfc: true,props, emit, dismissBanner }
}

})